function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M68.3811 45.6617L68.3341 26.2957V11.4834H34.1671C15.2968 11.4834 0 26.8216 0 45.7417C0 64.6618 15.2968 80 34.1671 80C53.0364 80 68.3341 64.6618 68.3341 45.7417V45.7361L68.3811 45.6608V45.6617Z",
  fill: "#F2F2F2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M34.866 41.6809C29.1647 41.6809 23.899 43.1681 19.6435 45.6806L17.449 30.1326C16.9439 26.5507 13.63 24.057 10.048 24.5621C6.466 25.0682 3.97235 28.3812 4.47748 31.9631L9.81376 69.7705C16.0117 76.085 24.6327 80 34.1661 80C43.7842 80 52.4739 76.0145 58.6831 69.6021C59.8363 67.2787 60.4694 64.7465 60.4694 62.0958C60.4694 50.8212 49.0057 41.6809 34.865 41.6809H34.866Z",
  fill: "#2368CC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M47.7161 0H20.3819C17.5195 0 15.199 2.32049 15.199 5.18296V59.366C15.199 62.2285 17.5195 64.549 20.3819 64.549H47.7161C50.5786 64.549 52.8991 62.2285 52.8991 59.366V5.18296C52.8991 2.32049 50.5786 0 47.7161 0Z",
  fill: "#0E3163"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M47.433 1.29715H20.6659C18.5251 1.29715 16.7896 3.03267 16.7896 5.17355V59.4065C16.7896 61.5473 18.5251 63.2829 20.6659 63.2829H47.433C49.5738 63.2829 51.3093 61.5473 51.3093 59.4065V5.17355C51.3093 3.03267 49.5738 1.29715 47.433 1.29715Z",
  fill: "#C0EFFF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M39.9342 0.670685H28.1629C27.3837 0.670685 26.752 1.3024 26.752 2.08165V2.44004C26.752 3.2193 27.3837 3.85101 28.1629 3.85101H39.9342C40.7134 3.85101 41.3451 3.2193 41.3451 2.44004V2.08165C41.3451 1.3024 40.7134 0.670685 39.9342 0.670685Z",
  fill: "#0E3163"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M34.3753 36C40.1383 36 44.8101 31.3282 44.8101 25.5652C44.8101 19.8023 40.1383 15.1305 34.3753 15.1305C28.6124 15.1305 23.9406 19.8023 23.9406 25.5652C23.9406 31.3282 28.6124 36 34.3753 36Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.0745 27.1283C33.274 26.9288 33.5876 26.9414 33.7745 27.1283C33.968 27.3218 33.968 27.6347 33.7745 27.8283C33.5809 28.0218 33.268 28.0218 33.0745 27.8283C32.8809 27.6347 32.8809 27.3218 33.0745 27.1283Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.1375 27.1283C35.337 26.9288 35.6506 26.9414 35.8375 27.1283C36.031 27.3218 36.031 27.6347 35.8375 27.8283C35.6439 28.0218 35.331 28.0218 35.1375 27.8283C34.9439 27.6347 34.9439 27.3218 35.1375 27.1283Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.5488 23.3188C37.805 23.3188 38.0127 23.5265 38.0127 23.7827V27.4786C38.0127 27.7348 37.805 27.9425 37.5488 27.9425C37.2925 27.9425 37.0848 27.7348 37.0848 27.4786V23.7827C37.0848 23.5265 37.2925 23.3188 37.5488 23.3188Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.3632 23.3188C31.6194 23.3188 31.8271 23.5265 31.8271 23.7827V27.4786C31.8271 27.7348 31.6194 27.9425 31.3632 27.9425C31.107 27.9425 30.8993 27.7348 30.8993 27.4786V23.7827C30.8993 23.5265 31.107 23.3188 31.3632 23.3188Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.4871 23.3188C35.7433 23.3188 35.951 23.5265 35.951 23.7827V25.9941C35.951 26.2503 35.7433 26.458 35.4871 26.458C35.2309 26.458 35.0232 26.2503 35.0232 25.9941V23.7827C35.0232 23.5265 35.2309 23.3188 35.4871 23.3188Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.4249 23.3188C33.6811 23.3188 33.8888 23.5265 33.8888 23.7827V25.9941C33.8888 26.2503 33.6811 26.458 33.4249 26.458C33.1686 26.458 32.9609 26.2503 32.9609 25.9941V23.7827C32.9609 23.5265 33.1686 23.3188 33.4249 23.3188Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.3632 20.5427C30.253 20.5427 29.3529 21.4429 29.3529 22.553V28.7386C29.3529 29.8488 30.253 30.7489 31.3632 30.7489H37.5488C38.6589 30.7489 39.5591 29.8488 39.5591 28.7386V22.553C39.5591 21.4429 38.6589 20.5427 37.5488 20.5427H31.3632ZM28.425 22.553C28.425 20.9304 29.7406 19.6149 31.3632 19.6149H37.5488C39.1714 19.6149 40.4869 20.9304 40.4869 22.553V28.7386C40.4869 30.3612 39.1714 31.6767 37.5488 31.6767H31.3632C29.7406 31.6767 28.425 30.3612 28.425 28.7386V22.553Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M60.4703 39.6397C60.4703 36.4453 57.8807 33.8557 54.6863 33.8557H46.7755C43.5811 33.8557 40.9915 36.4453 40.9915 39.6397C40.9915 42.2961 42.7824 44.533 45.2225 45.2112C42.7824 45.8903 40.9915 48.1262 40.9915 50.7826C40.9915 52.9931 42.2312 54.913 44.0533 55.8866C42.2312 56.8601 40.9915 58.78 40.9915 60.9905C40.9915 64.1849 43.5811 66.7745 46.7755 66.7745H52.9847L56.006 66.6212C58.5646 66.0239 60.4703 63.7306 60.4703 60.9896V39.8091H60.4656C60.4675 39.7517 60.4703 39.6952 60.4703 39.6388V39.6397Z",
  fill: "#2368CC"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M47.4302 38.4517C45.0635 38.4517 43.0111 37.5214 42.3225 36.1358C42.3065 36.1039 42.3046 36.0662 42.3178 36.0333C42.3263 36.0107 43.2114 33.8124 46.0738 33.8124H52.2341C52.2755 33.8124 52.315 33.8331 52.3385 33.867C52.6254 34.2781 52.7712 34.7155 52.7712 35.1689C52.7712 36.9796 50.3754 38.4526 47.4293 38.4526L47.4302 38.4517ZM42.5774 36.0738C43.2415 37.3267 45.2244 38.1968 47.4302 38.1968C50.2352 38.1968 52.5163 36.8385 52.5163 35.1689C52.5163 34.7888 52.3987 34.4192 52.1664 34.0683H46.0729C43.5971 34.0683 42.7223 35.7492 42.5765 36.0747L42.5774 36.0738Z",
  fill: "black"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M47.4302 49.5955C45.0635 49.5955 43.0111 48.6652 42.3225 47.2797C42.3065 47.2477 42.3046 47.2101 42.3178 47.1771C42.3263 47.1546 43.2114 44.9563 46.0738 44.9563H52.2341C52.2755 44.9563 52.315 44.977 52.3385 45.0108C52.6254 45.4219 52.7712 45.8593 52.7712 46.3127C52.7712 48.1234 50.3754 49.5965 47.4293 49.5965L47.4302 49.5955ZM42.5774 47.2176C43.2415 48.4705 45.2244 49.3406 47.4302 49.3406C50.2352 49.3406 52.5163 47.9823 52.5163 46.3127C52.5163 45.9327 52.3987 45.563 52.1664 45.2121H46.0729C43.5971 45.2121 42.7223 46.8931 42.5765 47.2185L42.5774 47.2176Z",
  fill: "black"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M47.005 60.143C44.6384 60.143 42.5859 59.2127 41.8973 57.8271C41.8813 57.7951 41.8795 57.7575 41.8926 57.7246C41.9011 57.702 42.7862 55.5037 45.6486 55.5037H51.8089C51.8503 55.5037 51.8898 55.5244 51.9133 55.5583C52.2002 55.9693 52.346 56.4067 52.346 56.8601C52.346 58.6709 49.9502 60.1439 47.0041 60.1439L47.005 60.143ZM42.1523 57.765C42.8163 59.018 44.7992 59.8881 47.005 59.8881C49.81 59.8881 52.0911 58.5298 52.0911 56.8601C52.0911 56.4801 51.9735 56.1104 51.7412 55.7596H45.6477C43.1719 55.7596 42.2971 57.4405 42.1513 57.766L42.1523 57.765Z",
  fill: "black"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M57.8084 55.7586H51.8409C51.7704 55.7586 51.713 55.7013 51.713 55.6307C51.713 55.5602 51.7704 55.5028 51.8409 55.5028H57.8084C57.8789 55.5028 57.9363 55.5602 57.9363 55.6307C57.9363 55.7013 57.8789 55.7586 57.8084 55.7586Z",
  fill: "black"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M57.8084 45.2112H51.8409C51.7704 45.2112 51.713 45.1538 51.713 45.0833C51.713 45.0127 51.7704 44.9553 51.8409 44.9553H57.8084C57.8789 44.9553 57.9363 45.0127 57.9363 45.0833C57.9363 45.1538 57.8789 45.2112 57.8084 45.2112Z",
  fill: "black"
});

function SvgHandWithMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 80,
    viewBox: "0 0 69 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
}

var ForwardRef = React.forwardRef(SvgHandWithMobile);
export default __webpack_public_path__ + "static/media/hand-with-mobile.f7758746.svg";
export { ForwardRef as ReactComponent };